export const CREDIT_CARD_PAYMENT_METHOD = 'credit_card';

export function areAllPaymentMethodsSelected(selectedMethods, availableMethodTypes) {
    if (!Array.isArray(selectedMethods) || !Array.isArray(availableMethodTypes)) {
        return false;
    }

    return (
        availableMethodTypes.length > 0 &&
        availableMethodTypes.every((methodType) => selectedMethods.includes(methodType))
    );
}

export function resolveDefaultPaymentMethod(selectedMethods, availableMethodTypes) {
    if (!Array.isArray(selectedMethods) || selectedMethods.length === 0) {
        return '';
    }

    if (
        areAllPaymentMethodsSelected(selectedMethods, availableMethodTypes) &&
        selectedMethods.includes(CREDIT_CARD_PAYMENT_METHOD)
    ) {
        return CREDIT_CARD_PAYMENT_METHOD;
    }

    return selectedMethods[0];
}
